import ReactDOM from "react-dom";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

import App from "./App";
import config from "./app.config.json";
import AggregatedLogger from "./observability/AggregatedLogger/AggregatedLogger";

import "./i18n";
import "./assets/styles/colors.css";
import "./assets/styles/fonts.css";

LogRocket.init(config.logrocket_app_id, {
  console: {
    shouldAggregateConsoleErrors: true,
    isEnabled: false,
  },
});

// TODO: Conditionally log to console when on prod/qa?
// Keep for now while in alpha/beta
AggregatedLogger.addLogger(console);
AggregatedLogger.addLogger(LogRocket);

setupLogRocketReact(LogRocket);

ReactDOM.render(<App />, document.getElementById("root"));
